import React from "react";
import { Chart } from "react-google-charts";

export const data = [
  [
    "Month",
    "ToPlan",
    "Planned",
    "InExecution",
    "Executed",
    "Cancelled",
    "Average",
  ],
  ["2004/05", 165, 938, 522, 998, 450, 614.6],
  ["2005/06", 135, 1120, 599, 1268, 288, 682],
  ["2006/07", 157, 1167, 587, 807, 397, 623],
  ["2007/08", 139, 1110, 615, 968, 215, 609.4],
  ["2008/09", 136, 691, 629, 1026, 366, 569.6],
];

export const options = {
  //title: "Monthly Coffee Production by Country",
  //vAxis: { title: "Cups" },
  hAxis: { title: "Month" },
  seriesType: "bars",
  series: { 5: { type: "line" } },
  legend: 'top',
  fontName: 'Roboto' , 
  fontSize: 13,
  //backgroundColor: '#ECECEC',
  colors: ['#2cb4d4','#1787b8','#255b98','#2f306d'],
  animation: {
    startup: true,
    easing: "linear",
    duration: 500,
  },
};

export default function BarChart() {
  return (
    <Chart
      chartType="ComboChart"
      width="100%"
      height="250px"
      title={null}
      data={data}
      options={options}
    />
  );
}




